// Service-worker update toast — "a new version is ready, reload" for browser
// clients (relay PWA + cloud). The SW installs updates WITHOUT skipWaiting
// (prompt-then-promote, packages/app/pwa/sw.template.js); this toast is the
// user-gated promotion step. Electron never registers a SW, so this renders
// nothing there — the desktop's own updater flow is UpdateBanner.
//
// Deliberately a persistent inline bar (not an auto-dismissing toast): version
// skew is a correctness problem, and the reload is user-timed.
import { RefreshCw } from 'lucide-react';
import type { JSX } from 'react';
import { Button } from '@onestone/ui/button';
import { useSWUpdate } from '@/lib/pwa';

export function SWUpdateToast(): JSX.Element | null {
  const { updateReady, applyUpdate } = useSWUpdate();
  if (!updateReady) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-between gap-3 border-b border-border bg-muted/40 px-4 py-2"
    >
      <p className="text-xs text-muted-foreground">
        A new version of OneStone is ready.{' '}
        <span className="hidden sm:inline">Reloading applies it to every open tab.</span>
      </p>
      <Button size="sm" variant="outline" className="h-7 gap-1.5 text-xs" onClick={applyUpdate}>
        <RefreshCw className="h-3 w-3" aria-hidden="true" />
        Reload
      </Button>
    </div>
  );
}
